/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OrgComplianceSettingsRequestCandidateNameDisplayMode = typeof OrgComplianceSettingsRequestCandidateNameDisplayMode[keyof typeof OrgComplianceSettingsRequestCandidateNameDisplayMode] | null;


export const OrgComplianceSettingsRequestCandidateNameDisplayMode = {
  show_all: 'show_all',
  anonymized: 'anonymized',
  initials_only: 'initials_only',
} as const;
